<template>
  <v-container v-editable="blok" class="mt-5 mb-5 py-0">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" class="pa-0 ma-0">
        <div class="title mb-5">
          <h2>{{blok.title}}</h2>

          <div class="pb-icon">
            <div class="before">
              <span>►</span>
            </div>
            <figure>
              <img src="@/assets/logo_mini_dark.svg" alt />
            </figure>
            <div class="after">
              <span>◄</span>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4"   v-for="(item, index) in blok.items" :key="index">
          <p>{{item.name}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./Services.scss";
</style>